import { Enemy } from "../../enemies/Enemy";
import { CrossbowTurret } from "../CrossbowTurret";
import { Engine } from "../../Engine";
import { MathUtils } from "../../utils/MathUtils";
import { GameConstants } from "../../GameConstants";

export class Arrow {

    public id: number;
    public x: number;
    public y: number;
    public assignedEnemy: Enemy;
    public damage: number;
    public canonShoot: string;
    public turret: CrossbowTurret;
    public outOfStageBoundaries: boolean;

    private engine: Engine;
    private vx: number;
    private vy: number;

    // bullet speed in cells / tick
    constructor (p: {x: number, y: number}, angle: number, assignedEnemy: Enemy, damage: number, canonShoot: string, turret: CrossbowTurret, engine: Engine) {
        
        this.engine = engine;

        this.id = this.engine.bulletId;
        this.engine.bulletId ++;

        this.x = p.x;
        this.y = p.y;
        
        this.assignedEnemy = assignedEnemy;

        this.outOfStageBoundaries = false;

        this.damage = damage;
        this.canonShoot = canonShoot;

        this.turret = turret;

        this.vx = MathUtils.fixNumber(GameConstants.ARROW_SPEED * Math.cos(angle));
        this.vy = MathUtils.fixNumber( GameConstants.ARROW_SPEED * Math.sin(angle));
    }

    public destroy(): void {
        //
    }

    public update(): void {
        
        this.x = MathUtils.fixNumber(this.x + this.vx);
        this.y = MathUtils.fixNumber(this.y + this.vy);

        // ¿se salio de los limites del tablero?
        if (this.x < -1 || this.x > this.engine.boardSize.c + 1 || this.y < - 1 || this.y >  this.engine.boardSize.r + 1) {
            this.outOfStageBoundaries = true;
        }
    }

    public getPositionNextTick(): {x: number, y: number} {

        return {x: MathUtils.fixNumber(this.x + this.vx), y: MathUtils.fixNumber(this.y + this.vy)};
    }
}
